import mixpanel from "mixpanel-browser";
import { config } from "../configs";

type MixpanelProps = Record<string, string | number | boolean | null | Date>;

const MIXPANEL_TOKEN = config.REACT_APP_MIXPANEL_TOKEN || "";
const ENV = config.REACT_APP_ENVIRONMENT;

if (!MIXPANEL_TOKEN) {
  console.error(
    "Mixpanel token is missing. Analytics will not be initialized."
  );
}

mixpanel.init(MIXPANEL_TOKEN, {
  debug: ENV === "development",
});


const isImpersonating = () => localStorage.getItem("impersonating") === "true";

const Mixpanel = {
  identify: (userId: string) => {
    if (isImpersonating()) return;
    mixpanel.identify(userId);
  },

  track: (event: string, props?: MixpanelProps) => {
    if (isImpersonating()) return;
    mixpanel.track(event, {
      action_source: "frontend",
      ...props,
    });
  },

  reset: () => {
    mixpanel.reset();
  },
};

export default Mixpanel;
